import React from "react";
import ReactDOM from "react-dom/client";
//import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const rootElement = document.getElementById("rivalChatBot");
const helpType = rootElement?.dataset.helpType;
const lifeSuiteCode = rootElement?.dataset.lifesuiteCode;
const userRoles = rootElement?.dataset.userRoles || "";
const rosiPermissionLevel = rootElement?.dataset.rosiPermissionLevel || "user"; // added now for Dev10 Portal demo Sarah / Tom
const managerReviewWriterEnabled = rootElement?.dataset.managerReviewWriterEnabled === "true";

const root = ReactDOM.createRoot(document.getElementById("rivalChatBot"));
root.render(
  <React.StrictMode>
    <App helpType={helpType} lifeSuiteCode={lifeSuiteCode} userRoles={userRoles} rosiPermissionLevel={rosiPermissionLevel} managerReviewWriterEnabled={managerReviewWriterEnabled} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
